if (!customElements.get('bw-hero')) {
  customElements.define(
    'bw-hero',
    class BwHero extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.bw-hero__slide')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = 0;
        if (this.slides.length < 2) return;

        // Later slides ship without src/srcset (see bw-hero.liquid). Once the page is done, fetch the
        // next slide; each crossfade then fetches the one after it, a full interval ahead.
        const loadNext = () => this.load(this.slides[1]);
        if (document.readyState === 'complete') loadNext();
        else window.addEventListener('load', loadNext, { once: true });

        this.interval = Number(this.dataset.interval) || 7000;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
        this.paused = false; // set by the pause button
        this.held = false; // hover or keyboard focus inside the hero

        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.show(Number(dot.dataset.go));
            this.restart();
          })
        );

        if (this.autoplay) {
          this.pauseButton.hidden = false;
          this.pauseButton.addEventListener('click', () => this.togglePause());
          this.addEventListener('mouseenter', () => this.hold(true));
          this.addEventListener('mouseleave', () => this.hold(false));
          this.addEventListener('focusin', () => this.hold(true));
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.hold(false);
          });
          this.restart();
        }

        // Theme editor: jump to the slide being edited and stop cycling while it's selected
        document.addEventListener('shopify:block:select', (this.onBlockSelect = (event) => {
          const i = this.slides.indexOf(event.target);
          if (i === -1) return;
          this.held = true;
          this.show(i);
          this.restart();
        }));
        document.addEventListener('shopify:block:deselect', (this.onBlockDeselect = (event) => {
          if (this.slides.includes(event.target)) this.hold(false);
        }));
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      load(slide) {
        const img = slide.querySelector('img[data-src]');
        if (!img) return;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }

      show(next) {
        const count = this.slides.length;
        this.index = (next + count) % count;
        this.load(this.slides[this.index]);
        this.load(this.slides[(this.index + 1) % count]);
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      restart() {
        clearInterval(this.timer);
        if (!this.autoplay || this.paused || this.held) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
      }

      hold(held) {
        this.held = held;
        this.restart();
      }

      togglePause() {
        this.paused = !this.paused;
        this.classList.toggle('is-paused', this.paused);
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        this.restart();
      }
    }
  );
}
